import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

import { FinchLogoFlat } from '@/components/base/logos/FinchLogoFlat';
import { Button } from '@/components/ui/button';

export const OuchFallback = () => {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture('hard_crash');
  }, [posthog]);

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md text-center">
        {/* Upside down logo - dead bird symbolism */}
        <div className="mb-6 flex justify-center [&_button]:!cursor-default">
          <FinchLogoFlat
            disableLink
            style={{
              width: '120px',
              transform: 'rotate(180deg)',
              opacity: 0.8,
              filter: 'invert(1)', // Inverts white logo to black for light mode
            }}
          />
        </div>

        <h1 className="mb-3 text-2xl font-semibold text-slate-900">
          Ouch! We hit a snag.
        </h1>

        <p className="mb-8 text-base text-slate-600">
          Something went wrong while loading the page.
        </p>

        <Button
          onClick={() => window.location.reload()}
          className="bg-slate-900 text-white hover:bg-slate-800"
        >
          Try Again
        </Button>
      </div>
    </div>
  );
};
